import { render, staticRenderFns } from "./ConfigureAndPublish.vue?vue&type=template&id=5d4f0787&scoped=true&"
import script from "./ConfigureAndPublish.vue?vue&type=script&lang=js&"
export * from "./ConfigureAndPublish.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureAndPublish.vue?vue&type=style&index=0&id=5d4f0787&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4f0787",
  null
  
)

component.options.__file = "ConfigureAndPublish.vue"
export default component.exports